<div class="custom-actions-container" #popup *ngIf="showDialog">
  <ng-container *ngIf="!evalActions">
    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.referrals?.stageDetails?.length">
      {{actionsList?.referrals.stageName}}</p>
    <!-- Accessibility (SEDMS-9272 - Issue 10): [text] includes stage name prefix (e.g. 'Referral - View') so Kendo sets aria-label with full category context for screen readers; getActionName() displays only the action name visually -->
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.referrals.stageName)">
      <ng-template kendoMenuItemTemplate let-item="item">
        <span class="k-menu-link-text">{{ getActionName(item.text) }}</span>
      </ng-template>
      <ng-container *ngFor="let stage of actionsList?.referrals?.stageDetails">
        <kendo-menu-item *ngIf="stage?.actionName[0]" [text]="(actionsList?.referrals?.stageName || 'Referral') + ' - ' + stage?.actionName[0]">
        </kendo-menu-item>
        <kendo-menu-item *ngIf="stage?.actionName.length > 1 && stage?.actionName[1]" [text]="(actionsList?.referrals?.stageName || 'Referral') + ' - ' + stage?.actionName[1]">
        </kendo-menu-item>
      </ng-container>
    </kendo-menu>
    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.assessments?.stageDetails?.length">
      {{actionsList?.assessments.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.assessments.stageName)">
      <ng-template kendoMenuItemTemplate let-item="item">
        <span class="k-menu-link-text">{{ getActionName(item.text) }}</span>
      </ng-template>
      <ng-container *ngFor="let stage of actionsList?.assessments?.stageDetails">
        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="(actionsList?.assessments?.stageName || 'Evaluation') + ' - ' + actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>

    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.iep?.stageDetails?.length">{{actionsList?.iep.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.iep.stageName)">
      <ng-template kendoMenuItemTemplate let-item="item">
        <span class="k-menu-link-text">{{ getActionName(item.text) }}</span>
      </ng-template>
      <ng-container *ngFor="let stage of actionsList?.iep?.stageDetails">
        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="(actionsList?.iep?.stageName || 'IEP') + ' - ' + actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>
    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.placements?.stageDetails?.length">
      {{actionsList?.placements.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.placements.stageName)">
      <ng-template kendoMenuItemTemplate let-item="item">
        <span class="k-menu-link-text">{{ getActionName(item.text) }}</span>
      </ng-template>
      <ng-container *ngFor="let stage of actionsList?.placements?.stageDetails">

        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="(actionsList?.placements?.stageName || 'Placements') + ' - ' + actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>

    <!-- Reason for Delay -->
    <div class="italics-secondary-text" *ngIf="studentDetails?.rfd">
      This case requires a reason for delay to be entered before any actions can be taken.
    </div>

    <!-- KIP -->
    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.kip?.stageDetails?.length">
      {{actionsList?.kip.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.kip.stageName)">
      <ng-template kendoMenuItemTemplate let-item="item">
        <span class="k-menu-link-text">{{ getActionName(item.text) }}</span>
      </ng-template>
      <ng-container *ngFor="let stage of actionsList?.kip?.stageDetails">
        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="(actionsList?.kip?.stageName || 'KIP') + ' - ' + actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>
    <!-- Student -->
    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.student?.stageDetails?.length">
      {{actionsList?.student.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.student.stageName)">
      <ng-template kendoMenuItemTemplate let-item="item">
        <span class="k-menu-link-text">{{ getActionName(item.text) }}</span>
      </ng-template>
      <ng-container *ngFor="let stage of actionsList?.student?.stageDetails">
        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="(actionsList?.student?.stageName || 'Student') + ' - ' + actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>
    <!-- relatedServices -->
    <p class="!k-font-semibold !k-m-0" *ngIf="actionsList?.relatedService?.stageDetails?.length">
      {{actionsList?.relatedService.stageName}}</p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.relatedService.stageName)">
      <ng-template kendoMenuItemTemplate let-item="item">
        <span class="k-menu-link-text">{{ getActionName(item.text) }}</span>
      </ng-template>
      <ng-container *ngFor="let stage of actionsList?.relatedService?.stageDetails">
        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="(actionsList?.relatedService?.stageName || 'Related Services') + ' - ' + actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>

    <!-- Handle Capture FAD -->
    <kendo-menu [vertical]="true" (select)="onSelect($event, actionsList?.miscellaneous?.stageName)">
      <ng-template kendoMenuItemTemplate let-item="item">
        <span class="k-menu-link-text">{{ getActionName(item.text) }}</span>
      </ng-template>
      <ng-container *ngFor="let stage of actionsList?.miscellaneous?.stageDetails">
        <ng-container *ngIf="stage?.actionName?.length">
          <ng-container *ngFor="let actionName of stage?.actionName">
            <kendo-menu-item *ngIf="actionName" [text]="(actionsList?.miscellaneous?.stageName ? actionsList?.miscellaneous?.stageName + ' - ' : '') + actionName">
            </kendo-menu-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </kendo-menu>
  </ng-container>

  <ng-container *ngIf="evalActions">
    <p class="italics-secondary-text wrap-text !k-m-0" *ngIf="showEtaMessage(evalActions)">
      This assessment type requires an approved AT <br />
      Referral before an evaluator can be assigned.
    </p>
    <kendo-menu [vertical]="true" (select)="onSelect($event, 'evaluationsNested')">
      <ng-template kendoMenuItemTemplate let-item="item">
        <span class="k-menu-link-text">{{ getActionName(item.text) }}</span>
      </ng-template>
      <ng-container *ngFor="let name of evalActions.actionName">
        <kendo-menu-item *ngIf="name" [text]="'Evaluation - ' + name">
        </kendo-menu-item>
      </ng-container>
      <ng-container *ngFor="let name of evalActions.subActionDetails">
        <ng-container *ngFor="let details of name.actionName">
          <kendo-menu-item *ngIf="details" [text]="'Evaluation - ' + details">
          </kendo-menu-item>
        </ng-container>
      </ng-container>
    </kendo-menu>
  </ng-container>

</div>


<div kendoDialogContainer></div>